import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
  Container, Typography, Box, Card, CardContent,
  CircularProgress, Alert, Stepper, Step, StepLabel, Grid
} from '@mui/material';
import logisticsService from '../../services/logistics.service';

const steps = ['Pending', 'Assigned', 'Picked Up', 'In Transit', 'Delivered'];

const LogisticsTracking = () => {
  const { trackingNumber } = useParams();
  const [tracking, setTracking] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    logisticsService.trackOrder(trackingNumber)
      .then(data => setTracking(data.tracking))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [trackingNumber]);

  if (loading) return <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh"><CircularProgress /></Box>;
  if (!tracking) return <Alert severity="error">Colis non trouvé</Alert>;

  const activeStep = steps.indexOf(tracking.order_status);

  return (
    <Container maxWidth="md">
      <Box sx={{ mt: 4, mb: 4 }}>
        <Typography variant="h3" gutterBottom fontWeight={700}>
          Suivi de colis
        </Typography>
        <Typography variant="h6" color="text.secondary">
          #{trackingNumber}
        </Typography>
      </Box>

      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Stepper activeStep={activeStep} alternativeLabel>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </CardContent>
      </Card>

      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>Départ</Typography>
              <Typography variant="body2">{tracking.pickup_address}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>Destination</Typography>
              <Typography variant="body2">{tracking.delivery_address}</Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};

export default LogisticsTracking;
